module.exports = {"placeholder":"Customer Code","continue":"Continue","wrongCode":"You have entered an invalid code"}